import useSWR from "swr";
import { getClientInfo } from "./clients-service";
import { ApiResponse, ClientInformation, UseClientsModel } from "./types";

const formatApiResponse = (response: ApiResponse): ClientInformation[] =>
  response.results.map((item) => item.clientInformation);

const useClients = (): UseClientsModel => {
  const { data, error, mutate } = useSWR(`/clients`, () => getClientInfo());

  return {
    data: data ? formatApiResponse(data) : [],
    dataCount: data?.results.length ?? 0,
    isLoading: !error && !data,
    error,
    mutate,
  };
};

export default useClients;
